import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./sentry";
import App from "./app";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
